import { MatrixDescriptor } from './types';

export const MATEMATICA_DESCRIPTORS: MatrixDescriptor[] = [
  {
    id: 'MAT_D1',
    subject: 'MATEMATICA',
    code: 'D1',
    theme: 'Tema 1 – Espaço e forma',
    description: 'Identificar figuras semelhantes mediante o reconhecimento de relações de proporcionalidade.',
    keywords: ['semelhantes', 'semelhança', 'proporcionalidade', 'razão', 'homotetia'],
  },
  {
    id: 'MAT_D2',
    subject: 'MATEMATICA',
    code: 'D2',
    theme: 'Tema 1 – Espaço e forma',
    description: 'Reconhecer aplicações das relações métricas do triângulo retângulo em um problema que envolva figuras planas ou espaciais.',
    keywords: ['triângulo retângulo', 'pitágoras', 'hipotenusa', 'cateto', 'relações métricas'],
  },
  {
    id: 'MAT_D3',
    subject: 'MATEMATICA',
    code: 'D3',
    theme: 'Tema 1 – Espaço e forma',
    description: 'Caracterizar polígonos regulares inscritos e circunscritos em circunferências.',
    keywords: ['polígono regular', 'inscrito', 'circunscrito', 'apótema', 'circunferência'],
  },
  {
    id: 'MAT_D4',
    subject: 'MATEMATICA',
    code: 'D4',
    theme: 'Tema 1 – Espaço e forma',
    description: 'Identificar a relação entre o número de vértices, faces e/ou arestas de poliedros expressa em um problema (Relação de Euler).',
    keywords: ['euler', 'poliedro', 'vértices', 'faces', 'arestas', 'v - a + f = 2'],
  },
  {
    id: 'MAT_D5',
    subject: 'MATEMATICA',
    code: 'D5',
    theme: 'Tema 1 – Espaço e forma',
    description: 'Resolver problemas que envolvam razões trigonométricas em triângulos.',
    keywords: ['seno', 'cosseno', 'tangente', 'razões trigonométricas', 'triângulo'],
  },
  {
    id: 'MAT_D6',
    subject: 'MATEMATICA',
    code: 'D6',
    theme: 'Tema 1 – Espaço e forma',
    description: 'Representar pontos, figuras, relações e equações em sistemas de coordenadas cartesianas.',
    keywords: ['coordenadas cartesianas', 'plano cartesiano', 'abscissa', 'ordenada', 'par ordenado'],
  },
  {
    id: 'MAT_D7',
    subject: 'MATEMATICA',
    code: 'D7',
    theme: 'Tema 1 – Espaço e forma',
    description: 'Reconhecer a equação da reta e o significado de seus coeficientes.',
    keywords: ['equação da reta', 'coeficiente angular', 'coeficiente linear', 'declividade', 'intercepto'],
  },
  {
    id: 'MAT_D8',
    subject: 'MATEMATICA',
    code: 'D8',
    theme: 'Tema 1 – Espaço e forma',
    description: 'Relacionar a determinação do ponto de intersecção de duas ou mais curvas com a resolução de um sistema de equações.',
    keywords: ['intersecção', 'curvas', 'sistema de equações', 'ponto de corte'],
  },
  {
    id: 'MAT_D9',
    subject: 'MATEMATICA',
    code: 'D9',
    theme: 'Tema 1 – Espaço e forma',
    description: 'Identificar e determinar as equações da circunferência e das cônicas.',
    keywords: ['circunferência', 'cônica', 'elipse', 'hipérbole', 'parábola', 'raio do círculo'],
  },
  {
    id: 'MAT_D10',
    subject: 'MATEMATICA',
    code: 'D10',
    theme: 'Tema 2 – Grandezas e medidas',
    description: 'Resolver problemas que envolvam cálculo de perímetro e área de figuras planas.',
    keywords: ['perímetro', 'área', 'figuras planas', 'área do triângulo', 'trapézio', 'quadrado'],
  },
  {
    id: 'MAT_D11',
    subject: 'MATEMATICA',
    code: 'D11',
    theme: 'Tema 2 – Grandezas e medidas',
    description: 'Resolver problemas que envolvam relações métricas fundamentais (comprimentos, áreas e volumes) de sólidos como o prisma e o cilindro.',
    keywords: ['prisma', 'cilindro', 'volume do cilindro', 'área da base', 'área lateral'],
  },
  {
    id: 'MAT_D12',
    subject: 'MATEMATICA',
    code: 'D12',
    theme: 'Tema 2 – Grandezas e medidas',
    description: 'Resolver problemas que envolvam relações métricas fundamentais (comprimentos, áreas e volumes) de sólidos como a pirâmide e o cone.',
    keywords: ['pirâmide', 'cone', 'volume do cone', 'geratriz', 'altura'],
  },
  {
    id: 'MAT_D13',
    subject: 'MATEMATICA',
    code: 'D13',
    theme: 'Tema 2 – Grandezas e medidas',
    description: 'Resolver problemas que envolvam relações métricas fundamentais (comprimentos, áreas e volumes) da esfera e suas partes.',
    keywords: ['esfera', 'volume da esfera', 'área da esfera', 'fuso esférico', 'cunha'],
  },
  {
    id: 'MAT_D14',
    subject: 'MATEMATICA',
    code: 'D14',
    theme: 'Tema 2 – Grandezas e medidas',
    description: 'Identificar fusos, latitudes e longitudes com as propriedades características da esfera terrestre.',
    keywords: ['meridiano', 'greenwich', 'fuso horário', 'latitude', 'longitude', 'esfera terrestre', 'fusos'],
  },
  {
    id: 'MAT_D18',
    subject: 'MATEMATICA',
    code: 'D18',
    theme: 'Tema 3 – Números e operações/ álgebra e funções',
    description: 'Representar por meio de funções, relações de proporcionalidade direta, inversa, e direta com o quadrado.',
    keywords: ['proporcionalidade direta', 'inversamente proporcional', 'razão e proporção'],
  },
  {
    id: 'MAT_D19',
    subject: 'MATEMATICA',
    code: 'D19',
    theme: 'Tema 3 – Números e operações/ álgebra e funções',
    description: 'Resolver problemas que envolva porcentagem.',
    keywords: ['porcentagem', 'desconto', 'acréscimo', '%', 'lucro', 'juros'],
  },
  {
    id: 'MAT_D20',
    subject: 'MATEMATICA',
    code: 'D20',
    theme: 'Tema 3 – Números e operações/ álgebra e funções',
    description: 'Resolver problemas envolvendo equações e inequações do 1.º grau e do 2.º grau.',
    keywords: ['equação do segundo grau', 'bhaskara', 'raízes', 'inequação'],
  },
  {
    id: 'MAT_D22',
    subject: 'MATEMATICA',
    code: 'D22',
    theme: 'Tema 3 – Números e operações/ álgebra e funções',
    description: 'Resolver problema envolvendo uma função polinomial do 1.º grau.',
    keywords: ['função afim', '1º grau', 'f(x) = ax + b', 'taxa de variação'],
  },
  {
    id: 'MAT_D24',
    subject: 'MATEMATICA',
    code: 'D24',
    theme: 'Tema 3 – Números e operações/ álgebra e funções',
    description: 'Identificar o gráfico que representa uma situação descrita em um texto.',
    keywords: ['gráfico', 'análise gráfica', 'curva', 'eixos', 'comportamento'],
  },
  {
    id: 'MAT_D25',
    subject: 'MATEMATICA',
    code: 'D25',
    theme: 'Tema 3 – Números e operações/ álgebra e funções',
    description: 'Resolver problemas que envolvam Progressões Aritméticas e/ou Progressões Geométricas.',
    keywords: ['progressão aritmética', 'progressão geométrica', 'pa', 'pg', 'razão', 'termo geral'],
  },
  {
    id: 'MAT_D27',
    subject: 'MATEMATICA',
    code: 'D27',
    theme: 'Tema 3 – Números e operações/ álgebra e funções',
    description: 'Descrever as características fundamentais da função polinomial do segundo grau, relativas ao crescimento, decrescimento, valores máximo ou mínimo, variação do sinal e análise gráfica.',
    keywords: ['parábola', 'máximo', 'mínimo', 'vértice', 'yv', 'xv', 'altura máxima', 'função quadrática'],
  },
  {
    id: 'MAT_D29',
    subject: 'MATEMATICA',
    code: 'D29',
    theme: 'Tema 3 – Números e operações/ álgebra e funções',
    description: 'Identificar a representação algébrica e/ou gráfica de uma função exponencial.',
    keywords: ['exponencial', 'função exponencial', '2^x', 'e^x', 'crescimento exponencial'],
  },
  {
    id: 'MAT_D30',
    subject: 'MATEMATICA',
    code: 'D30',
    theme: 'Tema 3 – Números e operações/ álgebra e funções',
    description: 'Reconhecer as funções Exponencial e Logarítmica e suas propriedades.',
    keywords: ['logaritmo', 'propriedades dos logaritmos', 'log', 'inversa'],
  },
  {
    id: 'MAT_D43',
    subject: 'MATEMATICA',
    code: 'D43',
    theme: 'Tema 3 – Números e operações/ álgebra e funções',
    description: 'Aplicar os raciocínios combinatórios aditivo e/ou multiplicativo na resolução de situações-problema.',
    keywords: ['análise combinatória', 'arranjo', 'combinação', 'fatorial', 'permutação'],
  },
  {
    id: 'MAT_D44',
    subject: 'MATEMATICA',
    code: 'D44',
    theme: 'Tema 3 – Números e operações/ álgebra e funções',
    description: 'Resolver problemas que envolvam o cálculo de probabilidades de eventos que se repetem seguidamente; o binômio de Newton e o triângulo de Pascal.',
    keywords: ['probabilidade', 'espaço amostral', 'eventos', 'sorteio', 'chance'],
  },
  {
    id: 'MAT_D46',
    subject: 'MATEMATICA',
    code: 'D46',
    theme: 'Tema 4 – Tratamento da informação',
    description: 'Calcular e interpretar medidas de tendência central de uma distribuição de dados (média, mediana e moda) e de dispersão (desvio padrão).',
    keywords: ['média', 'mediana', 'moda', 'desvio padrão', 'variância'],
  },
];
